import Vue from "vue"
import bugsnag from "@bugsnag/js"
import bugsnagVue from "@bugsnag/plugin-vue"

const _BUGSNAG = bugsnag("be8e37661cb648ddb9e79ba6091e2c6b").use(
  bugsnagVue,
  Vue
)

export default _BUGSNAG
